<template>
  <div class="right-cont">
    <div class="page-name help-detail-top">用户协议</div>
    <div class="help-detail-right" v-html="content"></div>
  </div>
</template>

<script>
import { getListByTypeCode } from "@/http/user_center";

export default {
  name: "UserAgreement",
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      getListByTypeCode({ type_code: "yonghuxieyi" }).then((res) => {
        this.content = res.data.yonghuxieyi;
      });
    },
  },
};
</script>

<style scoped src="../../assets/css/user_center.css"></style>
